package com.essntl.features.client.ui.addeditclient

interface AddEditClientNavigation {
    data class EditProposal(val proposalId: String) : AddEditClientNavigation
    data class EditItinerary(val itineraryId: String) : AddEditClientNavigation
}